// import { hasAuthority } from '@/utils/authority-utils'
import { loginIgnore } from '@/router/index'
import { checkAuthorization } from '@/utils/request'
import NProgress from 'nprogress'
import { setCookie } from '@/utils/request'
import { WX, APP_TYPE } from '@/config'

NProgress.configure({ showSpinner: false })

/**
 * 进度条开始
 * @param to
 * @param form
 * @param next
 */
const progressStart = (to, from, next) => {
  // start progress bar
  if (!NProgress.isStarted()) {
    NProgress.start()
  }
  next()
}

/**
 * 登录守卫
 * @param to
 * @param form
 * @param next
 * @param options
 */
const loginGuard = (to, from, next, options) => {
  const { message } = options
  if (!loginIgnore.includes(to) && !checkAuthorization()) {
    message.warning('登录已失效，请重新登录')
    if (APP_TYPE === WX) {
      next({ path: '/wx/login' })
    } else {
      next({ path: '/login' })
    }
  } else {
    next()
  }
}

/**
 * 进度条结束
 * @param to
 * @param form
 * @param options
 */
const progressDone = () => {
  // finish progress bar
  NProgress.done()
}

/**
 * set MenuId to cookie
 * @param {*} to
 * @param {*} from
 * @param {*} options
 */
const mountRouteInfo = (to, from, options) => {
  // reset MenuId
  setCookie('MenuId', '')
  const { store } = options
  const routesConfig = store.getters['account/routesConfig']
  function findRouteExtra(tree, cb) {
    if (tree) {
      for (const child of tree) {
        if (
          child.router &&
          typeof child.router === 'string' &&
          String('/' + child.router).includes(to.path)
        ) {
          cb(child)
          return
        } else if (child.childrenExtra) {
          findRouteExtra(child.childrenExtra, cb)
        } else if (child.children) {
          findRouteExtra(child.children, cb)
        }
      }
    }
  }
  findRouteExtra(routesConfig, child => {
    setCookie('MenuId', child.MenuId)
  })
  // check account.user
  if (!store.state.account.user) {
    store.getters['account/user']
  }
}

export default {
  beforeEach: [progressStart, loginGuard],
  afterEach: [progressDone, mountRouteInfo]
}
